var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-100 h-100", attrs: { id: "sidebar-left-mobile" } },
    [
      _c("div", { staticClass: "h-100 d-flex flex-column" }, [
        _c(
          "div",
          { staticClass: "h-100" },
          [
            _vm.activeStage.mainJob === null
              ? _c("upload-item-medium")
              : _vm._e(),
            _vm._v(" "),
            _vm.activeStage.activeStep === "draw"
              ? _c("draw-item-mobile")
              : _vm._e(),
            _vm._v(" "),
            _vm.activeStage.activeStep === "prompt"
              ? _c("prompt-item-medium")
              : _vm._e(),
            _vm._v(" "),
            _vm.activeStage.activeStep === "settings"
              ? _c("settings-item-medium")
              : _vm._e(),
            _vm._v(" "),
            _vm.activeStage.activeStep === "generate"
              ? _c("generate-item")
              : _vm._e(),
            _vm._v(" "),
            _vm.activeStage.activeStep === "select_output"
              ? _c("select-output-item")
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }